import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../agents';
import { IBookingList, IBookingSearchParams, IHALSyncResult } from '../models/IBooking';

export default class BookingStore {
    bookingList: IBookingList | undefined = undefined;
    loading: boolean = false;
    apiOperationError: string = '';

    searchParams: IBookingSearchParams = {
        facilityId: '',
        status: 'Active',
        bookedBy: '',
        searchText: '',
        createdFrom: '',
        createdTo: '',
        sortBy: 'createdOn',
        sortDescending: true,
        pageNumber: 1,
        pageSize: 50,
    };

    //bookingId of the row a HAL sync is currently running for
    syncingBookingId: string = '';
    lastSyncResult: IHALSyncResult | undefined = undefined;

    constructor() {
        makeAutoObservable(this);
    }

    setSearchParams = (params: Partial<IBookingSearchParams>) => {
        this.searchParams = { ...this.searchParams, ...params };
    };

    loadBookings = async () => {
        this.loading = true;
        this.apiOperationError = '';
        try {
            const result = await agent.Booking.search(this.searchParams);
            runInAction(() => {
                this.bookingList = result;
            });
        } catch (error) {
            runInAction(() => {
                this.apiOperationError =
                    (error as any)?.errorMessage || (error as any)?.message || 'Failed to load bookings.';
            });
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    };

    syncBookingToHAL = async (bookingId: string): Promise<IHALSyncResult> => {
        this.syncingBookingId = bookingId;
        this.lastSyncResult = undefined;
        try {
            const result = await agent.Booking.syncToHAL(bookingId);
            runInAction(() => {
                this.lastSyncResult = result;
            });
            return result;
        } catch (error) {
            const failed: IHALSyncResult = {
                success: false,
                message: (error as any)?.errorMessage || (error as any)?.message || 'HAL sync failed.',
            };
            runInAction(() => {
                this.lastSyncResult = failed;
            });
            return failed;
        } finally {
            runInAction(() => {
                this.syncingBookingId = '';
            });
        }
    };

    getBookingPageLink = async (quoteNumber: string): Promise<string | undefined> => {
        try {
            return await agent.Booking.getBookingPageLink(quoteNumber);
        } catch {
            return undefined;
        }
    };
}
